/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon16Light = forwardRef('ArrowDUturnUpRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.832.126a.5.5 0 1 0-.664.748L12.685 4H7.5a5.5 5.5 0 1 0 0 11h4a.5.5 0 0 0 0-1h-4a4.5 4.5 0 1 1 0-9h5.185L9.168 8.126a.5.5 0 0 0 .664.748l3.66-3.253a1.5 1.5 0 0 0 0-2.242L9.831.126Z" })));
});
